import { render, staticRenderFns } from "./fence_warn.vue?vue&type=template&id=3212356e&"
import script from "./fence_warn.vue?vue&type=script&lang=js&"
export * from "./fence_warn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports